import React from 'react'

const Copy = () => {
  return (
    <div className='bg-[#c4704b] h-[60px]'>
        <span className='h-[60px] flex justify-center items-center text-white font-cc'>© 2021 Euphoria. All Rights Reserved.</span>
    </div>
  )
}

export default Copy